import { gettext } from '@eventbrite/i18n';
import {
    getFormValidationAdornment,
    TextField,
    Typography,
} from '@eventbrite/marmalade';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useAppContext } from '../../../AppContext';
import { CreateAccountFormValues } from '../types';

export enum PasswordFormFieldTestId {
    Field = 'PaswordFormField',
}

export const PasswordFormField = () => {
    const { control } = useFormContext<CreateAccountFormValues>();
    const { isSubmittingCreateAccountForm } = useAppContext();

    const passwordMessage = gettext(
        'Your password must be at least 8 characters.',
    ).toString();

    const PASSWORD_MIN_LENGTH = 8;

    return (
        <Controller
            name={'password'}
            control={control}
            rules={{
                required: {
                    value: true,
                    message: passwordMessage,
                },
                validate: {
                    validPassword: (value) => {
                        if (value && value.length < PASSWORD_MIN_LENGTH) {
                            return passwordMessage;
                        }
                        return true;
                    },
                },
            }}
            render={({ field, fieldState: { error } }) => (
                <>
                    <TextField
                        autoComplete="off"
                        data-testid={PasswordFormFieldTestId.Field}
                        hasError={!!error}
                        helperText={error && error.message}
                        id={`create-account-password-field`}
                        label={gettext('Password').toString()}
                        maxLength={100}
                        type="password"
                        validationAdornment={getFormValidationAdornment({
                            hasError: !!error,
                        })}
                        {...field}
                        value={field.value || ''}
                        onChange={(value) => {
                            field.onChange({
                                target: { value },
                            });
                        }}
                        disabled={isSubmittingCreateAccountForm}
                        required
                    />
                    {!error && field.value?.length < PASSWORD_MIN_LENGTH && (
                        <Typography as="p" variant="body-sm">
                            {passwordMessage}
                        </Typography>
                    )}
                </>
            )}
        />
    );
};
